import { render, staticRenderFns } from "./ConceptDeliveryTable.vue?vue&type=template&id=344e8b14&"
import script from "./ConceptDeliveryTable.vue?vue&type=script&lang=ts&"
export * from "./ConceptDeliveryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports